module.exports = __webpack_public_path__ + "static/media/maersk_logo.0fa48895.png";